/**
 * View Service
 *
 * supposed to be used inside an app
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import _get from 'lodash-es/get';
import _find from 'lodash-es/find';

// Import RxJs required methods


import { ConfigurationResourceService } from '../service/resources/configuration/configurationResource.service';

@Injectable()
export class ViewsService {

    public view: Observable<any>;

    public display = {"root": ""};

    constructor(private configurationResource: ConfigurationResourceService) {
    }

    /**
     * Get json View when opening an App
     * Don't reload it if already provided
     *
     * @param {string} applicationName
     */
    public getView(applicationName: string) {
        const appFolder = "app_"+applicationName;

        this.view = this.configurationResource.get<any>(
            [ 'wui', appFolder, 'config', 'views', 'view.json'],
            {}
        );
    }


    /**
     * can this item be shown ?
     * @return: boolean
     *
     * @param {string} pageName
     * @param {string[]} path
     */
    public canShow(view: any, pageName: string, path: string) {
        const pageViews = _get(view, ['pages', pageName]);
        const requiredView = _find(pageViews, (v) => v.active === true);
        return _get(requiredView, path, true);
    }
}
